import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompaniesContractDialogComponent } from 'src/app/companies/companies-contract-dialog/companies-contract-dialog.component';
import { Company } from 'src/app/core/companies.service';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-home-companies-item',
  templateUrl: './home-companies-item.component.html',
  styleUrls: ['./home-companies-item.component.scss'],
})
export class HomeCompaniesItemComponent {
  @Input() company?: Company;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private utils_service: UtilsService,
    private dialog_service: DialogService,
    private error_service: ErrorService,
  ) {}

  onContractClick(company?: Company): void {
    this.dialog_service
      .openDialog(CompaniesContractDialogComponent, { company })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        } else {
          this.refresh.emit();
        }
      });
  }

  getCompanyStatusBackgroundClass(company?: Company): { [key: string]: boolean } {
    if (!company) return {};
    return this.utils_service.getCompanyStatusBackgroundClass(company);
  }
}
